/**
 * Sistema de carga lazy y cache para preguntas de pruebas
 * 
 * Optimiza el rendimiento cargando bloques bajo demanda y
 * manteniendo un cache para evitar recargas innecesarias.
 * 
 * @author Ana Lizcano
 */

const questionLoaders = {
  loadBlockA: () => import('./blocks/blockA.js').then(module => module.default),
  loadBlockB: () => import('./blocks/blockB.js').then(module => module.default),
  loadBlockC: () => import('./blocks/blockC.js').then(module => module.default),
  loadBlockD: () => import('./blocks/blockD.js').then(module => module.default)
};

const questionCache = new Map();

/**
 * Carga un bloque específico con cache automático
 */
export const loadBlockQuestions = async (blockKey) => {
  const cacheKey = `block${blockKey}`;
  
  if (questionCache.has(cacheKey)) {
    return questionCache.get(cacheKey);
  }
  
  const loaderKey = `loadBlock${blockKey}`;
  if (!questionLoaders[loaderKey]) {
    throw new Error(`Bloque ${blockKey} no encontrado`);
  }
  
  try {
    const questions = await questionLoaders[loaderKey]();
    questionCache.set(cacheKey, questions);
    return questions;
  } catch (error) {
    throw error;
  }
};


/**
 * Funciones de compatibilidad y utilidad
 */
export const getBlockTitle = (blockKey) => {
  const titles = {
    A: 'Selección de características personales',
    B: 'Test de Situaciones', 
    C: 'Preferencias Musicales',
    D: ''
  };
  return titles[blockKey] || '';
};

export const getBlockInstructions = (blockKey) => {
  const instructions = {
    A: 'Para cada grupo de características, selecciona UNA con la que MÁS te identifies y UNA con la que MENOS te identifies.',
    B: 'Para cada situación, ordena las opciones del 1 al 4 según tu preferencia, donde 4 es la más importante y 1 la menos importante.',
    C: 'Escucha los fragmentos musicales e indica tus preferencias. Luego deberás elegir entre pares de canciones.',
    D: `Observa la imagen en el recuadro. Asigna un número a cada dibujo propuesto según tu preferencia:
   1 → El que más te guste (solo uno).
   2 → El segundo que más te guste (solo uno).
   No seleccionado → Los demás (no marques nada en ellos).`
  };
  return instructions[blockKey] || '';
};

export const getQuestionsByBlock = () => {
  return {
    A: 24,
    B: 10,
    C: 6, 
    D: 1
  };
};

export const getTotalQuestions = () => {
  const blocks = getQuestionsByBlock();
  return Object.values(blocks).reduce((total, count) => total + count, 0);
};

